/**
 * The one time this site asks to measure anything.
 *
 * Small, quiet, and in the corner: it is a question, not an obstacle, and it
 * blocks nothing behind it. There is no third button and no settings panel —
 * two answers, and the globe works the same either way.
 */
export default function ConsentBar({ onAllow, onDecline }) {
  return (
    <aside className="consent" role="region" aria-label="Cookies">
      <p className="consent-note">
        We use cookies to improve your experience and to understand how the
        site is used.
      </p>
      <div className="consent-actions">
        <button type="button" className="btn btn-primary btn-sm" onClick={onAllow}>
          Allow
        </button>
        <button type="button" className="btn btn-sm" onClick={onDecline}>
          No thanks
        </button>
      </div>
    </aside>
  );
}
